export default __webpack_public_path__ + "static/media/lgV5C.ef6ce400.png";